<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1">Dédié à Vicki Childs, pour toutes ces conversations qui commencent par « Alors, as-tu écrit quelque chose dernièrement ? » et qui se terminent par « Continue d’écrire ! ». Un demi-siècle d’amitié avec toi ne me suffit toujours pas.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?4054c7b2